// extracted by mini-css-extract-plugin
export default {"modal":"Form_modal__54O5B","form":"Form_form__pqnm5","title":"Form_title__k-Hxr","fields":"Form_fields__gkLoL","error":"Form_error__6nNJD","button":"Form_button__Xm+9M"};